import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import ExpensesOverview from './ExpensesOverview'
import LatestExpensesTable from './LatestExpensesTable'
import Expenses from './Expenses'
import GetOverallProjectExpenses from '../../../APIs/AddExpense/GetOverallProjectExpenses'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

export default function ExpensesOverviewIndex() {
  // X-axis labels
  const salePurchase = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"]

  // Dummy Graph Data
  const DUMMY_GRAPH_DATA = [
    {
      label: 'Office ',
      data: [500, 700, 800, 600, 900, 750, 850],
      backgroundColor: '#E3E4ED',
      barThickness: 10,
      borderRadius: 6,
    },
    {
      label: 'Project ',
      data: [400, 600, 700, 500, 800, 650, 700],
      backgroundColor: '#3E4095',
      barThickness: 10,
      borderRadius: 6,
    },
  ]

  const [salePurchaseData, setSalePurchaseData] = useState(DUMMY_GRAPH_DATA)
  const [expensesType, setExpensesType] = useState(1)
  const [expensesData, setExpensesData] = useState([])

  const getData = async () => {
    let response = await GetOverallProjectExpenses(expensesType)
    if (response?.status === 1) {
      setExpensesData(response.responseValue)
      // Future: API se graph data update karna ho to yahi setSalePurchaseData call kar sakte ho
    }
  }

  useEffect(() => {
    getData()
  }, [expensesType])

  // Dummy cards data
  const dummyExpensesData = {
    officeExpense: 12000,
    projectExpense: 15000,
    pending: 5000,
  }

  const graphData = {
    labels: salePurchase,
    datasets: salePurchaseData,
  }

  // const graphOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       align: 'end',
  //       labels: {
  //         usePointStyle: true,   // circle legend
  //         pointStyle: 'circle',
  //         boxWidth: 8,
  //         boxHeight: 8,
  //         padding: 20,
  //         color: '#6B6F93',
  //       },
  //     },
  //     tooltip: {
  //       enabled: true,
  //     },
  //   },
  //   scales: {
  //     x: {
  //       grid: { display: false }, // remove vertical grid lines
  //       ticks: {
  //         color: '#1F2559',
  //         font: { weight: '600' },
  //       },
  //     },
  //     y: {
  //       grid: { display: false }, // remove horizontal grid lines
  //       ticks: {
  //         color: '#6B6F93',
  //         stepSize: 200,
  //         callback: (value) => `${value} ₹`,
  //       },
  //     },
  //   },
  // }
const graphOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false , // ❌ Chart ka default legend band
    },
    tooltip: {
      enabled: true,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        color: '#1F2559',
        font: { weight: '600' },
      },
    },
    y: {
      grid: { display: false },
      ticks: {
        color: '#6B6F93',
        stepSize: 200,
        callback: (value) => `${value} ₹`,
      },
    },
  },
}

  return (
    <>
      <div className='row pb-3'>
        <div className='col col-md-8'>
          <div className='d-flex flex-column gap-3'>
            <ExpensesOverview expensesData={dummyExpensesData} />

            {/* Chart Container */}
            <div
              style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '20px',
                height: '440px',
              }}
            >
              {/* Header with title + legend + dropdown */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 style={{ fontWeight: '700', color: '#1F2559', margin: 0 }}>
                Expenses Activity
                </h5>

                <div className="d-flex align-items-center gap-3">
                  {/* Legend */}
     <div className="d-flex align-items-center gap-4">
  {DUMMY_GRAPH_DATA.map((item, index) => (
    <div key={index} className="d-flex align-items-center gap-2">
      <span
        style={{
          width: 12,
          height: 12,
          backgroundColor: item.backgroundColor,
          borderRadius: '50%',
          display: 'inline-block',
        }}
      ></span>

      <span style={{ color: '#6B6F93', fontSize: '14px' }}>
        {item.label}
      </span>
    </div>
  ))}
</div>


                  {/* Dropdown */}
                  <select
                    style={{
                      border: '1px solid #EDEDED',
                      borderRadius: '8px',
                      padding: '6px 10px',
                      outline: 'none',
                      color: '#6B6F93',
                    }}
                    onChange={(e) => setExpensesType(Number(e.target.value))}
                    value={expensesType}
                  >
                    <option value={1}>Monthly</option>
                    <option value={2}>Yearly</option>
                  </select>
                </div>
              </div>

              {/* Chart */}
                <Bar data={graphData} options={graphOptions} />
            </div>
                 
          </div>
        </div>

        <div className='col col-md-4'>
          <div className='d-flex flex-column gap-3'>
            <Expenses
              expensesData={expensesData?.expenseById}
              setExpensesType={setExpensesType}
            />
          </div>
        </div>
      </div>

      <div className='row ps-3 pe-3'>
        <LatestExpensesTable expensesData={expensesData?.recentTransactions} />
      </div>
    </>
  )
}
